import React, { useEffect } from 'react';

const RedirectMobile = () => {
  const getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS';
    }

    return 'unknown';
  };
  useEffect(() => {
    const handleDownloadApp = () => {
      var mobileOS = getMobileOperatingSystem();

      if (mobileOS === 'Android' || mobileOS === 'unknown') {
        window.location.href =
          'https://play.google.com/store/apps/details?id=vn.kurio.android';
      } else if (mobileOS === 'iOS') {
        window.location.href =
          'https://apps.apple.com/us/app/to%C3%A1n-kurio/id6478091573';
      }
    };
    handleDownloadApp();
  }, []);
  return <div></div>;
};

export default RedirectMobile;
